import { render, staticRenderFns } from "./HcpPartners.vue?vue&type=template&id=5f4e3de0"
import script from "./HcpPartners.vue?vue&type=script&lang=js"
export * from "./HcpPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports